var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreen07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 100",
    style: {
      enableBackground: "new 0 0 70 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#183D71;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#4C708B;}\r\n\t.st3{fill:#A7CBF0;}\r\n\t.st4{fill:#D4B653;}\r\n\t.st5{fill:#BA8A5E;}\r\n\t.st6{fill:#6F3D37;}\r\n\t.st7{fill:#667352;}\r\n\t.st8{fill:#9BA658;}\r\n\t.st9{fill:#0F3F2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M58.7,32.1c0,7.7-6.2,13.9-13.9,13.9c-7.7,0-13.9-6.2-13.9-13.9c0-7.7,6.2-13.9,13.9-13.9 C52.5,18.2,58.7,24.5,58.7,32.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M35,47H4.9C3.3,47,2,48.3,2,49.9v19.4c0,1.6,1.3,2.9,2.9,2.9h11.8V79H7.8v2.2h24.3V79h-8.8v-6.7H35 c1.6,0,2.9-1.3,2.9-2.9V49.9C37.9,48.3,36.6,47,35,47z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M68,60.4c0-5-4.1-9.1-9.1-9.1H39.6v16.8c0,0-0.3,5.9-5.3,5.9s-9,0-9,0v2.1h8.3v5.7H68V60.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen07);
export default __webpack_public_path__ + "static/media/green07.5d89ecd077b711efecbd292a93f30aa8.svg";
export { ForwardRef as ReactComponent };